<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-04
      	描述：插件中心-优惠券
      -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">

      <el-tab-pane label="优惠券列表" name="list">
        <!--优惠券列表-->
        <List v-if="activeName == 'list'"></List>
      </el-tab-pane>
      <el-tab-pane label="领取记录" name="receive">
        <!--领取记录-->
        <Receive v-if="activeName == 'receive'"></Receive>
      </el-tab-pane>

      <!-- <el-tab-pane label="发送优惠券" name="cashrewords">
        <SendCoupon v-if="activeName == 'cashrewords'"></SendCoupon>
      </el-tab-pane> -->
    </el-tabs>




  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import List from './coupon/index';
import Receive from './coupon/Receive';
import SendCoupon from './coupon/SendCoupon';
export default {
  components: {
    List,
    Receive,
    SendCoupon
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {},
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'list',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'list',
          value: '优惠券列表',
          path: '/marketing/coupon/index'
        },
        {
          key: 'receive',
          value: '领取记录',
          path: '/marketing/coupon/coupon/receive'
        },
        {
          key: 'send',
          value: '发送优惠券',
          path: '/marketing/coupon/coupon/SendCoupon'
        }
      ],
      /*权限筛选后的数据*/
      tabList: [],
    };
  },
  created() {

  },
  beforeDestroy() {
  },
  methods: {


  }
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/marketing/coupon/index.vue